import BaseResource from './BaseResource'

export default class Images extends BaseResource {
  static endpoint = '/api/v1/images' // /base
}
